<template>	
	<el-row type="flex" justify="center">
		<el-col :xs="24" :sm="24" :md="24">
			<el-row>
				<el-col :xs="24" :sm="24" :md="24">
					<div class="lf_entry_info_box_left">
						<div class="lf_entry_info_box_left_tit">{{langs.FactSheet}}</div>
						<div class="lf_entry_info_box_left_con">
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.FactSheet}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									{{info.mtinfo?info.mtinfo.ColumnName:''}}
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.Time}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									{{info.mtinfo?info.mtinfo.mt_date:''}}
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.Venue}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									{{info.mtinfo?info.mtinfo.ColumnPlace:''}}
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.EntryFee}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									{{nvipFeeText}}
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.EntryDeadline}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									{{info.bmconfig?info.bmconfig.RegistEnd:''}}
								</div>
							</div>
							<div class="lf_line"></div>
						</div>
						<div class="lf_entry_info_box_left_tit">{{langs.text_Signupinfo}}</div>
						<div class="lf_entry_info_box_left_con">
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_Playersname}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-input disabled v-model="playerInfo.vipname" ></el-input>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									First Name
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-input disabled v-model="playerInfo.nvipfirstname" ></el-input>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									Last Name
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-input disabled v-model="playerInfo.nviplastname" ></el-input>
								</div>
							</div>

							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.entry_category}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-select  disabled v-model="playerInfo.zg_type" size="default" class="m-2">
										<el-option v-for="item in typecategory"
													:key="item.key"
													:label="item.value"
													:value="item.key" />
									</el-select>
								</div>
							</div>

							
							<div v-if="playerInfo.zg_type!='0' && playerInfo.zg_type!='Others'" class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									{{ langs.Your_current_ranking_in_this_category }}{{ playerInfo.zg_type_value }}
								</div>
							</div>
							


							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_IDtype}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-select disabled v-model="playerInfo.nvipidtype" size="default" class="m-2">
										<el-option v-for="item in nvipidtypeArr"
													:key="item.key"
													:label="item.value"
													:value="item.key" />
									</el-select>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_IDnumber}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-input disabled v-model="playerInfo.nvipidnumber" ></el-input>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_Gender}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-radio disabled v-model="playerInfo.nvipsex" label="1">女</el-radio>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.Identity}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-radio-group disabled  v-model="playerInfo.nvippro">
										<el-radio :label="'1'" >{{langs.text_Pro}}</el-radio>
										
									</el-radio-group >
									<el-radio-group  v-model="playerInfo.nvippro">
										
										<el-radio :label="'2'">{{langs.text_Am}}</el-radio>
									</el-radio-group>
									
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_Nationality}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-select disabled v-if="info.country" v-model="playerInfo.nvipnation" placeholder="请选择" size="default" class="m-2">
										<el-option v-for="item in info.country"
													:key="item.coun_id"
													:label="item.coun_name"
													:value="item.coun_id" />
									</el-select>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_Birthdate}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-date-picker
									disabled
									v-model="playerInfo.nvibirth"
									type="date"
									@change="changedata"
									:placeholder="langs.text_Selectdate" style="width: 4rem;">
									</el-date-picker>
								</div>
							</div>
							<div v-if="shownre" class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<div style="color: red;width: 4rem;">
										{{shownremsg}}
									</div>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_Relationtype}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-input disabled v-model="playerInfo.nviprelations"></el-input>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_Guardiansname}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-input disabled v-model="playerInfo.nvipguardianname"></el-input>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_Contactinfo}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-input disabled v-model="playerInfo.nvipguardiantel"></el-input>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.MobileNumber}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-input disabled v-model="playerInfo.nviptel"></el-input>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.EmailAddress}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-input disabled v-model="playerInfo.email"></el-input>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_IDofWorldWomensgolf}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-input disabled  v-model="playerInfo.wwgrid" :placeholder="systemlang=='cn'?'四位数字':'4 digits'"></el-input>
								</div>
							</div>
							
							
							<div class="lf_line"></div>
						</div>
						<div class="lf_entry_info_box_left_tit">{{langs.RelatedService}}</div>
						<div class="lf_entry_info_box_left_con">
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.Hotel}}
									<span class="lf_que_span" @click="downFlag">?</span>
									<div class="lf_que">
										<div class="lf_tips_box" v-if="down&&systemlang=='cn'">
											<div class="lf_tips_t">{{langs.OfficialHotel1}}： {{info.bmconfig.RegistHotelName}}</div>
											<div>
												请<text><a target="_blank" :href="'/uploadfile/hotelcaddie/'+info.hole.hc_match+'/hotel/'+info.hole.hc_hotel_file">下载酒店预订表</a></text>直接
											</div>
											<div>
												发送至酒店进行预订
											</div>
										</div>
										<div class="lf_tips_box" v-if="down&&systemlang=='en'">
											<div class="lf_tips_t">{{langs.OfficialHotel1}}： {{info.bmconfig.RegistHotelName}}</div>
											<div>
												<text><a target="_blank" :href="'/uploadfile/hotelcaddie/'+info.hole.hc_match+'/hotel/'+info.hole.hc_hotel_file">Download </a></text>
											</div>
											<div>
												the Official Hotel Booking Sheet
											</div>
										</div>
									</div>
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-radio-group disabled v-if="info.bmconfig" v-model="playerInfo.jd">
										<el-radio  :label="info.bmconfig.RegistHotelName">{{langs.OfficialHotel}}</el-radio>
									</el-radio-group>
									
									<el-radio-group disabled v-model="playerInfo.jd">
										<el-radio  :label="'自己安排'">{{langs.SelfArrangement}}</el-radio>
									</el-radio-group>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list"></div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.Caddie}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-radio-group disabled v-model="playerInfo.PlayRegCaddie">
										<el-radio  :label="'球会安排'">{{langs.CourseProvided}}</el-radio>
									</el-radio-group>
									<div class="lf_que" style="background-color: unset;"></div>
									<el-radio-group disabled  v-model="playerInfo.PlayRegCaddie">
										<el-radio  :label="'自带球童'">{{langs.SelfProvided}}</el-radio>
									</el-radio-group>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list"></div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_Airportpickupinfo}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right" style="flex-wrap: wrap;">
									<text  v-if="info.jiji && info.jiji.length < 1" >通知：接接机安排将于近期公布，望周知。</text>
									<el-radio-group disabled v-for="item in info.jiji" v-if="info.jiji && info.jiji.length >= 1" v-model="playerInfo.jiji">
										<el-radio  :label="item.id">{{item.pickuptime}}</el-radio>
									</el-radio-group>
									
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list"></div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									{{langs.text_Airportdropoffinfo}}
								</div>
								<div class="lf_entry_info_box_left_con_list_right" style="flex-wrap: wrap;">
									<text v-if="info.songji && info.songji.length < 1" >{{langs.text_Noticearrangementsforpickup}}</text>
									<el-radio-group disabled v-for="item in info.songji"  v-if="info.songji && info.songji.length >= 1" v-model="playerInfo.songji">
										<el-radio  :label="item.id">{{item.pickuptime}}</el-radio>
									</el-radio-group>
								</div>
							</div>
							<div class="lf_entry_info_box_left_con_list"></div>
							<div class="lf_entry_info_box_left_con_list">
								<div class="lf_entry_info_box_left_con_list_left">
									
								</div>
								<div class="lf_entry_info_box_left_con_list_right">
									<el-button type="danger" @click="backlist" >{{langs.text_back}}</el-button>
								</div>
							</div>
							
						
						</div>
					</div>
				</el-col>
				
			</el-row>
		</el-col>
	</el-row>
</template>

<script>

import axios from '../../axios/request';
import axiosx from '../../axios/postx';
import axiojs from '../../axios/postjs';
 import {
        getSystemLang,
        getLangAll
    } from '../../lang';
    export default {
		data() {
		    return {
		        langs: '',
		        systemlang: 'cn',
                banner:{},
				input:'',
				mtid:'',
				playerInfo:{
					vipname:'',//球员姓名
					nvipfirstname:'',
					nviplastname:'',
					nvipidtype:'0', //身份类型
					nvipidnumber:'',//证件号
					nvipsex:'1',//性别
					nvippro:'', //身份
					nvipnation:'CHN',//国籍
					nvibirth:'',//出生日期
					nviprelations:'', //与监护人关系
					nvipguardianname:'', //监护人姓名
					nvipguardiantel:'', //监护人联系方式
					nviptel_cou:'', //国籍区号
					nviptel:'',//电话
					email:'',//邮箱
					wwgrid:'',//世界排名
					jd:'', //酒店信息
					PlayRegCaddie:'',//球童
					jiji:'',
					songji:'',
					checked:false
				},
				nvipidtypeArr:[
					{key:'0',value:'请选择证件类型'},
					{key:'二代身份证',value:'二代身份证'},
					{key:'港澳通行证',value:'港澳通行证'},
					{key:'台湾通行证',value:'台湾通行证'},
					{key:'护照',value:'护照'}
				],
				typecategory:[
					{key:'0',value:'请选择符合报名的参赛次序','cn_title':'请选择符合报名的参赛次序','en_title':'Please select your entry category'},
					{key:'CLPGA_Order_of_Merit',value:'女子中巡积分榜','cn_title':'女子中巡积分榜','en_title':'CLPGA Order of Merit'},
					{key:'CLPGQ_Order_of_Merit',value:'起点中巡积分榜','title':'起点中巡积分榜','cn_title':'起点中巡积分榜','en_title':'CLPGQ Order Of Merit'},
					{key:'Rolex_Women_World_Golf_Rankings',value:'世界排名','title':'世界排名','cn_title':'世界排名','en_title':'Rolex Women’s World Golf Rankings'},
					{key:'World_Amateur_Golf_Ranking',value:'世界业余排名','title':'世界业余排名','cn_title':'世界业余排名','en_title':'World Amateur Golf Ranking'},
					{key:'Others',value:'其他','title':'其他','cn_title':'其他','en_title':'Others'},
				],
				nvipproArr:[
					{key:'1',value:'职业'},
					{key:'2',value:'业余'}
				],
				shownre:false,
				shownremsg:'',
				info:{},
				down:false,
				jd:'',
				PlayRegCaddie:'',
				signage:0,//不可报名 1：可报名
				mtlist:[{
				  value: '1',
				  label: '1'
				},
				{
				  value: '2',
				  label: '2'
				}],
				value:'',
		    }
		},
        name: 'Entrynovipinfo',
        props: {
            msg: String,
			mt_id:String,
			parentgoDan:Object,
			orderid:String
        },
		components: {
			
        },
		created() {
			this.mtid = this.mt_id;
			this.getData();
			this.systemlang = getSystemLang();
			
			this.langs = getLangAll(this.systemlang);
			if(this.systemlang == 'en')
			{
				this.nvipidtypeArr = [
					{key:'0',value:'Please select a certificate type'},
					{key:'二代身份证',value:'Second generation ID card'},
					{key:'港澳通行证',value:'Hong Kong and Macao pass'},
					{key:'台湾通行证',value:'Taiwan Pass'},
					{key:'护照',value:'passport'}
				];

				this.typecategory.map(item=>{
					item.value = item.en_title;
				});
				
			}
		},
		watch:{
			mtid(newvalue)
			{
				this.mtid = newvalue;
				this.getData();
			}
		},
		computed:{
			nvipFeeText(){
				let raw = '';
				if(this.info && this.info.mtinfo){
					raw = this.info.mtinfo.RegistMatchTF ||  '';
				}
				let n = parseInt(raw);
				let nation = this.playerInfo ? this.playerInfo.nvipnation : '';
				let isCnArea = nation=='CHN'||nation=='MAC'||nation=='HKG'||nation=='TPE';
				if(n == 5000 && !isCnArea){
					return '6000 人民币';
				}
				return raw;
			}
		},
		methods:{
			/*跳转到订单列表*/
			backlist(){
				this.$emit('backlist');
			},
			sumitgo(){
				console.log('sssss');
				this.parentgoDan('csbmmd');
			},
			changedata(dd){
				var date = dd.getFullYear()+'-'+(dd.getMonth()+1)+'-'+(dd.getDate());
				console.log(date,'sssss');
				var $url = 'http://www.clpga.org/user/notvip_check.php?check=ages&birthday='+date+'&lang='+this.systemlang+'&matchid='+this.mtid;
				axiojs($url).then((res)=>{
					let data = res.data;
					data = eval("("+data+")");
					
					if(data['flag'] == '1'){
						this.signage = 0;
						this.shownre =true;
						this.shownremsg = data['mgs'];
						
					}else if(data['flag'] == '2'){
						this.signage = 1;
						this.shownre =true;
						this.shownremsg = data['mgs'];
					}else if(data['flag'] == '3'){
						this.shownre =true;
						this.signage = 0;
						this.shownremsg = data['mgs'];
					}else if(data['flag'] == '4'){
						this.signage = 1;
						this.shownre =true;
						this.shownremsg = data['mgs'];
						this.signage = 1;
					}else if(data['flag'] == '5'){
						this.shownre =true;
						
						if(confirm(data['mgs'])){
						this.signage = 1;
					}else{
						this.signage = 1;
					}
					}
					
					
				});
			},
			downFlag(){
				if(this.down == true)
				{
					this.down = false;
				}
				else
				{
					this.down = true;
				}
			},
			getData()
			{
				let param = {};
				if(this.mtid)
				{
					param.mt_id = this.mtid;
				}
				param.orderid = this.orderid;
				axios('user/notviporderinfodeil.json',param)
				.then((res)=>{
					let data = res.data.data;
					this.info = data;
					this.playerInfo = data.playerInfo;
					// this.info.jiji.push({id:158,pickuptime:'2020-12-23'});
					// this.info.jiji.push({id:4,pickuptime:'2020-12-24'});
					// this.info.songji.push({id:5,pickuptime:'2020-12-23'});
					// this.info.songji.push({id:6,pickuptime:'2020-12-24'});
					
					
				});
			},
			sumitData(){
			
				let param = {};
				if(this.signage == 0)
				{
					alert('年龄不符合规则');
					return false;
				}
				if(this.playerInfo.checked == false)
				{
					alert('请勾选相关协议');
					return false;
				}
				for(let i in this.playerInfo)
				{
					if(!param[i])
					{
						param[i] =  this.playerInfo[i];
					}
				}
				
				param.mt_id = this.mtid;
				axiosx('user/notviporderinfosave.json',param)
				.then((res)=>{
					let data = res.data;
					console.log(data);
					if(data.msgCode != '200')
					{
						alert(data.msg);
					}
					else
					{
						alert('Sucess');
						this.$emit('changTap','news',data.msg);
					}
					
					
				});
			}
		}
    }
</script>

<style scoped="scoped">
	.d_title {
		margin-top: 0.14rem;
		color: rgb(192, 21, 62);
		font-size: 0.2rem;
		padding-bottom: 4px;
		/* font-weight: bold; */
		font-family: '微软雅黑';
		border-bottom: 1px solid rgb(192, 21, 62);
		display: inline-block;
		padding-right: 30px;
	}

	.d_title span {
		font-size: 0.14rem;
	}
	.lf_match_info_box{
		padding: 0.35rem 0px;
		font-size: 0.14rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.lf_entry_info_box_left{
		padding-bottom: 0.7rem;
		background-color: #FAFAFA;
	}
	.lf_entry_info_box_left_tit{
		padding: 0.35rem 0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.18rem;
		color: #C0153E;
	}
	.lf_entry_info_box_left_con_list{
		display: flex;
		align-items: center;
		min-height: 0.5rem;
	}
	.lf_entry_info_box_left_con_list_left{
		width: 2.5rem;
		display: flex;
		justify-content: flex-end;
		font-size: 0.16rem;
		color: #999;
		flex-shrink: 0;
	}
	.lf_entry_info_box_left_con_list_left text{
		color: #C0153E;
		display: flex;
		align-items: center;
	}
	.lf_entry_info_box_left_con_list_right{
		display: flex;
		align-items: center;
		margin-left: 0.8rem;
		font-size: 0.16rem;
	}
	.lf_entry_info_box_left_con_list_right .el-select{
		width: 4rem;
	}
	.lf_entry_info_box_left_con_list_right .el-radio-group{
		width: 1.6rem;
	}
	.lf_entry_info_box_left_con_list_right .lf_que{
		width: 0.14rem;
		height: 0.14rem;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 0.24rem;
		margin-left: 0.1rem;
		margin-top: 2px;
		z-index: 1;
		margin-right: 0.2rem;
		position: relative;
	}
	.lf_entry_info_box_left_con_list_right .el-input{
		width: 4rem;
		height: 30px;
		background: inherit;
		background-color: rgba(239, 239, 239, 1);
		border: none;
		border-radius: 2px;
		-moz-box-shadow: none;
		-webkit-box-shadow: none;
		box-shadow: none;
		font-family: '微软雅黑';
		font-weight: 400;
		font-style: normal;
		font-size: 0.16rem;
		text-align: left;
	}
	.lf_entry_info_box_right{
		margin-left: 0.24rem;
		padding: 0 0.24rem 0.7rem;
		background-color: #FAFAFA;
	}
	.lf_entry_info_box_right_tit{
		padding: 0.35rem 0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 0.18rem;
		color: #C0153E;
	}
	.lf_entry_info_box_right_con{
		line-height: 0.4rem;
		color: #666666;
		font-size: 0.16rem;
		word-break: break-word;
	}
	.lf_line{
		width: 96%;
		border-bottom: 1px solid #EFEFEF;
		margin: 0.2rem auto 0;
	}
	.lf_tips_box{
		padding: 0.16rem 0.2rem;
		position: absolute;
		left: 0.2rem;
		top: -0.1rem;
		width: 3.2rem;
		background-color: #fff;
		border: 1px solid #A8A8A8;
		border-radius: 0.1rem;
		color: #333;
	}
	.lf_tips_box text{
		color: #C0153E;
	}
	.lf_tips_t{
		margin-bottom: 0.1rem;
	}
	@media screen and (max-width: 768px) {
		.lf_match_info_box{
			padding: 0.35rem 0.2rem;
			margin-left: 0;
		}
		.lf_entry_info_box_left_con_list_left{
			width: 1.8rem;
			display: flex;
			justify-content: flex-end;
			font-size: 0.16rem;
			color: #999;
		}
		.lf_tips_box{
			left: -0.4rem;
			top: 0.3rem;
			width: 3rem;
		}
		.lf_entry_info_box_left_con_list_right{
			margin-left: 0.3rem;
			min-height: 0.8rem;
			font-size: 0.26rem;
		}
		.lf_entry_info_box_left_con_list_right .el-radio-group{
			width: 2rem;
		}
		.lf_entry_info_box_left_con_list_right .lf_que{
			left: 0;
			width: 0.2rem;
			height: 0.2rem;
		}
		.lf_entry_info_box_left_con_list_right .el-input{
			height: 30px;
			font-size: 0.26rem;
		}
		.lf_entry_info_box_right{
			margin-left: 0;
			margin-top: 0.2rem;
		}
		.el-select {
		    margin-left: 0;
		}
		.lf_entry_info_box_left_tit{
			font-size: 0.26rem;
		}
	}
</style>
